import { Box, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotificationCount } from '../../../action/searchFilterAction';
import AHMIS, { API_URL } from '../../../api/api';
import AddAlertMessage from '../../../components/alert/Alert';
import CustomReactSelect from '../../../components/custom-react-select/CustomReactSelect';
import DeleteRegisterRecordConformation from '../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation';
import CustomModal from '../../../components/modal/CustomModal';
import MulDartaaSelect from '../../../components/mul-dartaa-select/MulDartaaSelect';
import PendingPatientList from '../../../components/pending-patient-list/PendingPatientList';
import RegisterHeader from '../../../components/register-header/RegisterHeader';
import RegisterNotificationBell from '../../../components/notification/RegisterNotificationBell';
import { useNotificationAccept } from '../../../components/notification/useNotificationAccept';
import { AppMisc } from '../../../misc/appMisc';
import { ERROR, OTHER_SEWA_CODE, REQUIRED_FIELD, ROW_PER_PAGE, SALYACHIKITA, SEWA_CODE, SOMETHING_WENT_WRONG, SUCCESS, NOTIFICATION_ACCEPTED } from '../../../utils/constants';
import { INVALID_BLOOD_PRESSURE_MESSAGE, MUL_DARTA_NUMBERS_LIST } from '../../../utils/constants/forms';
import { DateUtils } from '../../../utils/dateUtils';
import { SessionStorage } from '../../../utils/storage/sessionStorage';
import ShalyaChikitsaRegister from '../../users/components/register/shalya-chikitsa-register/ShalyaChikitsaRegister';
import { fetchPendingNotifications } from "../../../components/notification/notificationService";

const ShalyaChikitsaForm = () => {
  const [modalTitle, setModalTitle] = useState("शल्य चिकित्सा रजिस्टरमा नयाँ रेकर्ड थप्नुहोस् ।");
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch } = useForm();
  const [showShalyaChikitsaModal, setShowShalyaChikitsaModal] = useState(false)
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const [modalDefaultValues, setModalDefaultValues] = useState();
  const [shalyaChikitsTableData, setShalyaChikitsTableData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [shalyaChikitsaDeleteId, setShalyaChikitsaDeleteId] = useState(null);
  const [showShalyaChikitsaDeleteModal, setShowShalyaChikitsaDeleteModal] = useState(false);
  const [pendingPatientList, setPendingPatientList] = useState([])
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);
  const dispatch = useDispatch();
  const watchField = watch(["sewaCode"])


  const { handleAccept: handleNotificationAccept, addNotificationId } = useNotificationAccept({
    reset,
    setModalOpen: setShowShalyaChikitsaModal,
    setModalDefaultValues,
    transform: (data) => {
      if (data.palikaName) {
        data.palikaName = AppMisc.getMunicipalityName(data.palikaName);
      }
      return data;
    },
  });

  const openShalyaChikitsaModal = () => {
    setShowShalyaChikitsaModal(true);
  }

  const closeShalyaChikitsaModal = () => {
    reset({
      bloodPressure: "",
      nature: "",
      weight: "",
      disease: "",
      fbs: "",
      examination: "",
      sewaCode: null,
      testAndRecommendation: "",
      complication: "",
      others: "",
      referredOut: "",
      referredIn: "",
      patientFirstName: "",
      patientLastName: "",
      age: "",
      wardNumber: "",
      phoneNumber: "",
      nid: "",
      gaunOrTole: "",
      otherSewaCode: "",
      sewaDartaaNumber: "",
    });
    setShowShalyaChikitsaModal(false);
    setModalDefaultValues()
  }

  const handleSelectChange = (name, value) => {
    setValue(name, value)
  }

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  };

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    getShalyaChikisa(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const submitShalyaChikisaRegister = (data) => {
    const isFromNotification = !!modalDefaultValues?.notificationId;
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    data = addNotificationId(data);
    AHMIS.post(API_URL.shalyaChikitsa, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closeShalyaChikitsaModal();
          salyachikitsaPendingPatient()
          getShalyaChikisa(fromDate, toDate)
          if (isFromNotification) {
            dispatch(fetchNotificationCount(SALYACHIKITA));
          }
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  useEffect(() => {
    register("sewaCode", { required: true });
    register("otherSewaCode");
  }, [register]);

  useEffect(() => {
    if (fromDate && toDate) {
      getShalyaChikisa(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage])


  const getShalyaChikisa = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.shalyaChikitsa}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(pageNumber))}&rowSize=${rowsPerPage}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        setShalyaChikitsTableData(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.totalSize)
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const shalyaChikisaEdit = (id) => {
    AHMIS.get(API_URL.shalyaChikitsa + "/" + id)
      .then((response) => {
        const data = response?.data?.data;
        setModalDefaultValues(data);
        setShowShalyaChikitsaModal(true);
        if (data) {
          Object.keys(data).forEach((key) => {
            setValue(key, data[key]);
          });
        }
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const closeShalyaChikitsaDeleteModal = () => {
    setShowShalyaChikitsaDeleteModal(false);
    setShalyaChikitsaDeleteId(null);
  }

  const onDeleteShalyaChikitsaRow = (id) => {
    setShowShalyaChikitsaDeleteModal(true);
    setShalyaChikitsaDeleteId(id);
  }

  const deleteShalyaChikitsaRow = (data) => {
    AHMIS.delete(API_URL.shalyaChikitsa + "/" + shalyaChikitsaDeleteId + "?deleteReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowShalyaChikitsaDeleteModal(false);
          setShalyaChikitsaDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getShalyaChikisa(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?sewaType=3&fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }

  useEffect(() => {
    attachMulDartaaOptions();
  }, [])

  useEffect(() => {
    salyachikitsaPendingPatient()
  }, [])

  const salyachikitsaPendingPatient = () => {
    let url = `${API_URL.pendingPatient}?sewaType=${"3"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&registerConstant=${SALYACHIKITA}`;
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setPendingPatientList(jsondata.data);
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  return (
    <>
      <Box marginTop={3}>
        <RegisterHeader
          registerTitle="शल्य चिकित्सा सेवा रजिष्टर"
          handleModalOpen={openShalyaChikitsaModal}
          onHeaderParamChange={onHeaderParamChange}
          getRegisterData={getShalyaChikisa}
          lazyLoading
          showSearchField
          rightElement={<RegisterNotificationBell targetRegister={SALYACHIKITA} onAccept={handleNotificationAccept} />}
        />
        <CustomModal
          title={modalTitle}
          showModal={showShalyaChikitsaModal}
          onModalSubmit={handleSubmit(submitShalyaChikisaRegister)}
          onModalClose={closeShalyaChikitsaModal}
          fullScreen
        >
          <Grid container spacing={2} alignItems="center">
            <MulDartaaSelect
              mulDartaaOptions={mulDartaaOptions}
              defaultValues={modalDefaultValues}
              register={register}
              handleSubmit={handleSubmit}
              setValue={setValue}
              errors={errors}
              watch={watch}
              handleSelectedDartaaMitiChange={handleDateChange}
              registerConstant={SALYACHIKITA}
            />
          </Grid>
          <Box marginTop={2}>
            <Typography variant="h6">General Examination</Typography>
          </Box>
          <Box mt={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="रक्तचाप (Blood Pressure)"
                  size="small"
                  variant="outlined"
                  name="bloodPressure"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.bloodPressure}
                  {...register("bloodPressure", {
                    pattern: /^(0|[1-9][0-9]*)\/(0|[1-9][0-9]*)$/,
                  })}
                />
                {errors.bloodPressure && errors.bloodPressure.type === "pattern" && <span className="error-message">{INVALID_BLOOD_PRESSURE_MESSAGE}</span>}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="प्रकृति"
                  size="small"
                  variant="outlined"
                  name="nature"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.nature}
                  {...register("nature")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="तौल (KG)"
                  size="small"
                  variant="outlined"
                  name="weight"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.weight}
                  {...register("weight")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="रोग"
                  size="small"
                  variant="outlined"
                  name="disease"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.disease}
                  {...register("disease")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="एफविएस"
                  size="small"
                  variant="outlined"
                  name="fbs"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.fbs}
                  {...register("fbs")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="परीक्षण"
                  size="small"
                  variant="outlined"
                  name="examination"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.examination}
                  {...register("examination")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <CustomReactSelect
                  label="सेवा कोड"
                  name="sewaCode"
                  variant="outlined"
                  options={SEWA_CODE}
                  onChange={handleSelectChange}
                  defaultValue={modalDefaultValues?.sewaCode}
                  register={register}
                  required
                />
                {errors?.sewaCode && errors.sewaCode?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
              </Grid>
              {watchField && watchField.includes("6") && (
                <Grid item xs={12} sm={6} md={3}>
                  <CustomReactSelect
                    label="अन्य सेवा कोड"
                    name="otherSewaCode"
                    variant="outlined"
                    options={OTHER_SEWA_CODE}
                    onChange={handleSelectChange}
                    defaultValue={modalDefaultValues?.otherSewaCode}
                    register={register}
                    required
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="परिक्षण सल्लाह"
                  size="small"
                  variant="outlined"
                  name="testAndRecommendation"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.testAndRecommendation}
                  {...register("testAndRecommendation")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="जटिलता"
                  size="small"
                  variant="outlined"
                  name="complication"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.complication}
                  {...register("complication")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="अन्य"
                  size="small"
                  variant="outlined"
                  name="others"
                  autoComplete="true"
                  fullWidth
                  defaultValue={modalDefaultValues?.others}
                  {...register("others")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} >
                <TextField
                  label="प्रेषण भई आएको संस्थाको नाम"
                  size="small"
                  variant="outlined"
                  name="referredOut"
                  autoComplete="true"
                  defaultValue={modalDefaultValues?.referredOut}
                  fullWidth
                  {...register("referredOut")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} >
                <TextField
                  label="प्रेषण भई गएको संस्थाको नाम"
                  size="small"
                  variant="outlined"
                  name="referredIn"
                  autoComplete="true"
                  defaultValue={modalDefaultValues?.referredIn}
                  fullWidth
                  {...register("referredIn")}
                />
              </Grid>
            </Grid>
          </Box>
        </CustomModal>
        {
          pendingPatientList?.size > 0 &&
          <Box mt={2}>
            <PendingPatientList
              pendingPatientList={pendingPatientList}
              showModal={setShowShalyaChikitsaModal}
              modalDefaultValues={setModalDefaultValues}
              setValue={setValue}
            />
          </Box>
        }
      </Box>
      <DeleteRegisterRecordConformation
        showDeleteModal={showShalyaChikitsaDeleteModal}
        closeDeleteModel={closeShalyaChikitsaDeleteModal}
        deleteRecord={deleteShalyaChikitsaRow}
      />
      <ShalyaChikitsaRegister
        onEditRow={shalyaChikisaEdit}
        tableData={shalyaChikitsTableData}
        deleteRow={onDeleteShalyaChikitsaRow}
        totalSize={totalSize}
      />
    </>
  )
}

export default ShalyaChikitsaForm;
